import {
	WMS_FA_DAFTAR,
	WMS_LGS_PEMBELIAN,
	WMS_LGS_PO,
	WMS_LGS_DAFTAR_ADJUSMENT_STOCK,
	WMS_LGS_INPUT_ADJUSMENT_STOCK,
	WMS_LGS_DAFTAR_PO,
	WMS_LGS_PEMBAYARAN,
	WMS_LGS_DAFTAR_PEMBAYARAN,
	WMS_LGS_DAFTAR_PEMBELIAN,
	WMS_LGS_DAFTAR_ADJUST,
	WMS_LGS_INPUT_ADJUST,
	WMS_PBF_DAFTAR_PEMBELIAN,
	WMS_PBF_INPUT_ADJUSMENT_STOCK,
	WMS_PBF_PEMBELIAN,
	WMS_FA_REQUEST,
	WMS_FA_DAFTAR_REQUEST,
	WMS_FA_INPUT,
	WMS_FA_TRANSFER_ASSET,
	WMS_PBF_STOCK_OPNAME,
	WMS_PBF_DAFTAR_ADJUSMENT_STOCK,
	WMS_PBF_DAFTAR_STOCK_OPNAME,
	WMS_PBF_PEMBAYARAN,
	WMS_PBF_DAFTAR_PEMBAYARAN,
	WMS_FA_PO,
	WMS_FA_DAFTAR_PO,
	WMS_FA_PEMBELIAN,
	WMS_FA_DAFTAR_PEMBELIAN,
	WMS_FA_DAFTAR_PEMBAYARAN,
	WMS_FA_PEMBAYARAN,
	WMS_FA_PENGAJUAN_REQUEST,
	WMS_FA_PENGAJUAN,
	WMS_LGS_STOCK_OPNAME,
	WMS_LGS_DAFTAR_STOCK_OPNAME,
	WMS_PBF_DAFTAR_ADJUSMENT_UNIT,
	WMS_PBF_INPUT_ADJUSMENT_UNIT,
	RB_REQUEST,
	RB_PENGAJUAN,
	RB_DAFTAR_REQUEST,
	RB_DAFTAR_PENGAJUAN,
	WMS_FA_DAFTAR_TRANSFER_ASSET,
	WMS_FA_DAFTAR_KESELURUHAN_TRANSFER,
	WMS_FA_HELPDESK,
	WMS_FA_DAFTAR_HELPDESK,
	WMS_FA_DAFTAR_MAINTENANCE,
	WMS_FA_INPUT_MAINTENANCE,
	MOBILE_DAFTAR_PAKET_TELEKONSUL,
	MOBILE_INPUT_PAKET_TELEKONSUL,
} from "App/constants";
import React, { Suspense, useContext } from "react";
import {
	InputAdjusmentStockPerb,
	POLogistik,
	DaftarPoTransaksiGudangLogistik,
	PembelianWMSLogistik,
	PembayaranWMSLogistik,
	DaftarPembayaranWMSLogistik,
	DaftarPembelianWMSLogistik,
	StockOpnameLogistik,
	DaftarStockOpnameLogistik,
	RequestFixedAsset,
	DaftarRequestFixedAsset,
	InputFixedAsset,
	DaftarFixedAsset,
	TransferAssetFixedAsset,
	StockOpnamePerbekalanFarmasi,
	DaftarAdjusmentStockPerbekalanFarmasi,
	Tema,
	DaftarStockOpnamePerbekalanFarmasi,
	InputAdjusmentStockLogistik,
	DaftarAdjusmentStockLogistik,
	InputAdjustLogistik,
	DaftarAdjustLogistik,
	POFixedAsset,
	DaftarPoFixedAsset,
	PembelianWMSFixedAsset,
	PembayaranWMSFixedAsset,
	DaftarPembayaranWMSFixedAsset,
	DaftarPembelianWMSFixedAsset,
	PengajuanRequestFixedAsset,
	PengajuanFixedAsset,
	DaftarAdjusmentUnitPerbekalanFarmasi,
	InputAdjusmentUnitPerb,
	RequestBarang,
	PengajuanRequestBarang,
	DaftarRequestBarang,
	DaftarPengajuanRequest,
	DaftarTransferAssetFixedAsset,
	DaftarKeseluruhanTransfer,
	DaftarHelpDesk,
	HelpDesk,
	DaftarMaintenance,
	InutMaintenance,
	InputPaketTelekonsul,
	DaftarPaketTelekonsul,
} from "../../index";
import Departemen from "../Akuntansi/Master/Departemen/Departemen";
import MasterGolonganFixAsset from "../FixedAsset/Master/MasterGolonganBarang/MasterGolonganBarang";

import {
	WfDaftarPembayaranPage,
	WfDaftarPembelianPage,
	WfPembayaranPage,
	WfPembelianPage,
} from "./WrapperLazyExport";

import { WrapperCtx } from "./context/context";
import { changeActiveMenu, changePageProps } from "./context/actions";
import { menuAkutansi } from "./menus/akutansi";
import { LoadingBackdrop } from "components/atoms";
import { menuBilling, menuRekapTagihan } from "./menus/billing";
import { menuFarmasi } from "./menus/farmasi";
import { menuRegistrasi } from "./menus/registrasi";
import { menuMaster } from "./menus/master";
import { menuLaporan } from "./menus/laporan";
import { menuLogistik } from "./menus/logistik";
import { menuFixedAsset } from "./menus/fixedAsset";
import { menuMobile } from "./menus/mobile";
import { menuManagement } from "./menus/management";
import { menuAntrian } from "./menus/antrian";
import { menuBPJS } from "./menus/bpjs";
import { menuDashboard } from "./menus/dashboard";
import { menuCasemix } from "./menus/casemix";
import { menuWsBPJS } from "./menus/wsbpjs";

export default function WrapperActiveMenu({
	active,
	handleChangeActive,
	tabs,
	handleClickMenu,
	props,
	menu,
}) {
	const { dispatch } = useContext(WrapperCtx);
	const handlePropsComponent = (data) => {
		dispatch(changePageProps(data));
	};

	const handleChangeMenu = (item) => {
		dispatch(changeActiveMenu(item));
	};

	const dataMenus = {
		DEPARTEMEN: <Departemen />,
		MASTERGOLONGANFA: <MasterGolonganFixAsset />,
		SETTING_TEMA: <Tema />,

		...menuBPJS,
		...menuMaster,
		...menuBilling,
		...menuFarmasi,
		...menuLogistik,
		...menuFixedAsset,
		...menuRekapTagihan,
		...menuMobile,
		...menuManagement,
		...menuDashboard,
		...menuWsBPJS,

		[WMS_PBF_PEMBELIAN]: (
			<WfPembelianPage
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_PBF_DAFTAR_PEMBELIAN]: (
			<WfDaftarPembelianPage
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_PBF_PEMBAYARAN]: (
			<WfPembayaranPage
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_PBF_DAFTAR_PEMBAYARAN]: (
			<WfDaftarPembayaranPage
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_PBF_DAFTAR_ADJUSMENT_STOCK]: (
			<DaftarAdjusmentStockPerbekalanFarmasi
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_PBF_DAFTAR_ADJUSMENT_UNIT]: (
			<DaftarAdjusmentUnitPerbekalanFarmasi
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_PBF_INPUT_ADJUSMENT_STOCK]: (
			<InputAdjusmentStockPerb data={props} menu={menu} />
		),

		[WMS_PBF_INPUT_ADJUSMENT_UNIT]: (
			<InputAdjusmentUnitPerb data={props} menu={menu} />
		),

		[WMS_PBF_STOCK_OPNAME]: (
			<StockOpnamePerbekalanFarmasi menu={menu} data={props} />
		),

		[WMS_PBF_DAFTAR_STOCK_OPNAME]: (
			<DaftarStockOpnamePerbekalanFarmasi
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				changeMenu={handleChangeMenu}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_PO]: <POLogistik data={props} menu={menu} />,

		[WMS_LGS_DAFTAR_PO]: (
			<DaftarPoTransaksiGudangLogistik
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_PEMBELIAN]: (
			<PembelianWMSLogistik
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_LGS_PEMBAYARAN]: (
			<PembayaranWMSLogistik
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_LGS_DAFTAR_PEMBAYARAN]: (
			<DaftarPembayaranWMSLogistik
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_DAFTAR_PEMBELIAN]: (
			<DaftarPembelianWMSLogistik
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_DAFTAR_ADJUSMENT_STOCK]: (
			<DaftarAdjusmentStockLogistik
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_INPUT_ADJUSMENT_STOCK]: (
			<InputAdjusmentStockLogistik data={props} menu={menu} />
		),

		[WMS_LGS_DAFTAR_ADJUST]: (
			<DaftarAdjustLogistik
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_LGS_INPUT_ADJUST]: <InputAdjustLogistik data={props} menu={menu} />,

		[WMS_LGS_STOCK_OPNAME]: <StockOpnameLogistik menu={menu} data={props} />,

		[WMS_LGS_DAFTAR_STOCK_OPNAME]: (
			<DaftarStockOpnameLogistik
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				changeMenu={handleChangeMenu}
				handleClickMenu={handleClickMenu}
			/>
		),

		// Fixed Asset
		[WMS_FA_INPUT]: (
			<InputFixedAsset
				changePage={handleChangeActive}
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
				changeMenu={handleChangeMenu}
			/>
		),
		[WMS_FA_DAFTAR]: (
			<DaftarFixedAsset
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				changeMenu={handleChangeMenu}
				handleClickMenu={handleClickMenu}
			/>
		),
		[WMS_FA_PO]: <POFixedAsset data={props} menu={menu} />,
		[WMS_FA_DAFTAR_PO]: (
			<DaftarPoFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),
		[WMS_FA_REQUEST]: <RequestFixedAsset data={props} menu={menu} />,
		[WMS_FA_PENGAJUAN]: <PengajuanFixedAsset data={props} menu={menu} />,
		[WMS_FA_DAFTAR_REQUEST]: (
			<DaftarRequestFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),
		[WMS_FA_PENGAJUAN_REQUEST]: (
			<PengajuanRequestFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_FA_PEMBELIAN]: (
			<PembelianWMSFixedAsset
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_FA_PEMBAYARAN]: (
			<PembayaranWMSFixedAsset
				data={props}
				menu={menu}
				changeParentData={handlePropsComponent}
			/>
		),

		[WMS_FA_DAFTAR_PEMBAYARAN]: (
			<DaftarPembayaranWMSFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_FA_DAFTAR_PEMBELIAN]: (
			<DaftarPembelianWMSFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		[WMS_FA_TRANSFER_ASSET]: (
			<TransferAssetFixedAsset data={props} menu={menu} />
		),
		[WMS_FA_DAFTAR_TRANSFER_ASSET]: (
			<DaftarTransferAssetFixedAsset
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),
		[WMS_FA_DAFTAR_KESELURUHAN_TRANSFER]: (
			<DaftarKeseluruhanTransfer
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		// Help Desk Maintenance
		[WMS_FA_HELPDESK]: <HelpDesk data={props} menu={menu} />,
		[WMS_FA_INPUT_MAINTENANCE]: <InutMaintenance data={props} menu={menu} />,
		[WMS_FA_DAFTAR_HELPDESK]: (
			<DaftarHelpDesk
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),
		[WMS_FA_DAFTAR_MAINTENANCE]: (
			<DaftarMaintenance
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		// Request Barang
		[RB_REQUEST]: <RequestBarang data={props} menu={menu} />,
		[RB_PENGAJUAN]: <PengajuanRequestBarang data={props} menu={menu} />,
		[RB_DAFTAR_REQUEST]: (
			<DaftarRequestBarang
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),
		[RB_DAFTAR_PENGAJUAN]: (
			<DaftarPengajuanRequest
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		// TELEKONSUL
		[MOBILE_INPUT_PAKET_TELEKONSUL]: (
			<InputPaketTelekonsul data={props} menu={menu} />
		),
		[MOBILE_DAFTAR_PAKET_TELEKONSUL]: (
			<DaftarPaketTelekonsul
				changeMenu={handleChangeMenu}
				changeTitle={handleChangeActive}
				changeParentData={handlePropsComponent}
				handleClickMenu={handleClickMenu}
			/>
		),

		//REGISTRASI
		...menuRegistrasi,
		...menuAkutansi,
		...menuLaporan,
		...menuAntrian,

		...menuCasemix,
	};

	return (
		<Suspense fallback={<LoadingBackdrop />}>
			{tabs?.map((tab) => (
				<div
					key={`content-${tab.code}`}
					id={tab.code}
					className="tabcontent"
					style={{ display: active === tab.code ? "block" : "none" }}
				>
					{dataMenus[tab.code]}
				</div>
			))}
		</Suspense>
	);
}
